module.exports = __webpack_public_path__ + "media/assets/icons/envelope-mail-grey-8e4312984c820ce50fb7cdce56876512.svg";